import { ColorStyles } from "../../../packages/ui"
import { SidebarTheme } from "../../../studio/Views/SidebarTheme"

ColorStyles.primary = ColorStyles.teal
SidebarTheme.light = false
SidebarTheme.background = "#130722"
